import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { RequestsService } from 'src/app/user-management/_services/requests.service';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { Router } from '@angular/router';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { MatSnackBar } from '@angular/material/snack-bar';
declare var $: any;
@Component({
  selector: 'app-decline-early-dismissal',
  templateUrl: './decline-early-dismissal.component.html',
  styleUrls: ['./decline-early-dismissal.component.scss']
})
export class DeclineEarlyDismissalComponent {
  editRequestForm: UntypedFormGroup;
  currLang;
  grades: any[];
  classes: any[];
  imageFile;
  selectedImage;
  image;
  requestDataSubscription;
  declineReason = ''
  isButtonDisabled: boolean = true;
  @Input("requestData") requestData = null;
  constructor(
    private dataService: DataService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private requestsService: RequestsService,
    private errorMsgService: ErrorMsgService,
    private router: Router,
    private snackBar: SnackbarService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component 
    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    $(document).on('hidden.bs.modal', '#declineEarlyDismissal', () => {
      this.closeModalHandler();
    });

    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    $(document).on('shown.bs.modal', '#declineEarlyDismissal', () => {
    })
  }

  closeModalHandler() {
    this.declineReason = '';
    $("#declineEarlyDismissal").modal("hide");
  }

  cancelEarlyDismissal() {
    let currentUrl = this.router.url
    let body:any = {};
    body.reason = this.declineReason;
    this.requestsService.cancelEarlyDismissalRequest(this.requestData?.id, body).subscribe(res => {
      this.router.navigateByUrl(`/`, { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
    },
      err => {
        this.errorMsgService.setReloadOnClose(true);
        this.closeModalHandler();
        this.errorMsgService.setMessage(err?.error?.message);
      })
  }

  onInputChange() {
    // Remove spaces and count characters
    const textWithoutSpaces = this.declineReason.replace(/\s/g, '');
    const characterCount = textWithoutSpaces.length;
    this.isButtonDisabled = characterCount < 5;
  }
}
